module.exports = __webpack_public_path__ + "static/media/1POLICY11.032f5e6d.jpg";